import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { EvaluationFormListItemFragment } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteEvaluationForm } from 'modules/ats/hooks/evaluationForms/useDeleteEvaluationForm'

interface Props {
  evaluationForm: EvaluationFormListItemFragment
  onClose: () => void
}

export const DeleteEvaluationForm = ({ evaluationForm, onClose }: Props) => {
  const { deleteEvaluationForm } = useDeleteEvaluationForm(evaluationForm.id)
  const isTemplate = !evaluationForm.atsJobPostingId

  const onDelete = async () => {
    const result = await deleteEvaluationForm()

    const handled = handleResult(result, () => undefined)
    setFlashMessage(handled.success)
    onClose()
  }

  const setFlashMessage = (success: boolean) => {
    const type = success ? 'correct' : 'wrong'
    const message = success
      ? i18n.t('ats.evaluation_forms.delete.success')
      : i18n.t('ats.evaluation_forms.delete.error')

    app.setFlash({
      type: type,
      message: message,
      time: 2000,
    })
  }

  return (
    <Dialog
      open
      onClose={onClose}
      header={{
        type: 'critical',
        title: isTemplate
          ? i18n.t('ats.evaluation_forms.delete_template.title')
          : i18n.t('ats.evaluation_forms.delete.title'),
        description: isTemplate
          ? i18n.t('ats.evaluation_forms.delete_template.description')
          : i18n.t('ats.evaluation_forms.delete.description'),
      }}
      actions={{
        primary: {
          label: isTemplate
            ? i18n.t('ats.evaluation_forms.delete_template.submit')
            : i18n.t('ats.evaluation_forms.delete.submit'),
          onClick: onDelete,
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onClose,
        },
      }}
    />
  )
}
